module.exports = __webpack_public_path__ + "1f0c962f.svg";